import api from "api";
import _ from "lodash";
import React, {createContext} from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useLocation, useParams, Link, Outlet, useNavigate } from "react-router-dom";
import stateMap from "store/stateMap";
import { connect } from 'react-redux';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import "../../../sass/tab/tab.scss";
import "./index.scss";
import ProfileBanner from "component/ProfileBanner";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import LoginBox from "component/LoginBox/LoginBox";

const UserContext = createContext({
    profile             : false
});

const PageProfileUser = connect(stateMap)((props) => {
    const [profile, setProfile]                     = useState(false);
    let navigate                                = useNavigate();
    const location = useLocation();

    const getCurrentPath = () => {
        let lastFragment = location.pathname.split('/').pop();

        switch(lastFragment)
        {
            case 'activity':
            case 'skill':
                return lastFragment;
            default:
                return 'experience';
        }
    }
    
    let {user_name} = useParams();

    useEffect(() => {

        if(props.auth.user)
        {
            if(user_name == props.auth.user.UserName)
            {
                // return navigate({
                //     pathname    : '/profile'  
                // });
            }
        }

        if(profile !== false)
        {
            return;
        }


        api('/Profile', 'get', {
            user_name : user_name
        })
            .then((response) => {
                setProfile(response.user);
            })
            .catch(() => {
                setProfile(404);
            });

    }, [props.auth.user]);
    
    return (
        <>
            <Header>
                {
                    profile !== false && profile !== 404 && <ProfileBanner profile={profile} />
                }
            </Header>
            {
                profile !== false && profile !== 404 && props.auth.user &&
                <div className="page-profile-user page-user">
                    {
                        getCurrentPath() != 'update' &&
                        <div className="profile-menus">
                            <div className=" tabs">
                                <Splide options={{
                                    autoWidth : true
                                    ,pagination : false
                                    ,arrows : false
                                }}>
                                    <SplideSlide>
                                        <div className={'tab ' + (getCurrentPath() == 'experience' ? 'active' : '') }>
                                            <Link to="./" className="tab-wrapper">Experience</Link>
                                        </div>
                                    </SplideSlide>
                                    <SplideSlide>
                                        <div className={'tab ' + (getCurrentPath() == 'skill' ? 'active' : '') }>
                                            <Link to="skill" className="tab-wrapper">Skill</Link>
                                        </div>
                                    </SplideSlide>
                                    <SplideSlide>
                                        <div className={'tab ' + (getCurrentPath() == 'activity' ? 'active' : '') }>
                                            <Link to="activity" className="tab-wrapper">Activity</Link>
                                        </div>
                                    </SplideSlide>
                                </Splide>
                            </div>
                        </div>
                    }
                    
                    <UserContext.Provider value={{
                        profile             : profile
                    }}>
                        <Outlet/>
                    </UserContext.Provider>
                </div>
            }
            {
                profile === false && <span className="skeleton"></span>
            }
            {
                profile !== false && profile === 404 && <div className="mt-4 mb-4 text-center bold">
                    Profile Not Found
                </div>
            }
            {
                !props.auth.user &&
                <div className="text-center container">
                    <span className="text-xs bold">Login to see {profile && profile.UserDisplayName } Profile </span>
                    <hr />
                    <LoginBox/>
                </div> 
            }
            <Footer/>
        </>
    )
});

export default PageProfileUser;

export {UserContext};